import { render } from "./SendAdditionalDocView.vue?vue&type=template&id=0b60c6c7&scoped=true"
import script from "./SendAdditionalDocView.vue?vue&type=script&lang=js"
export * from "./SendAdditionalDocView.vue?vue&type=script&lang=js"

import "./SendAdditionalDocView.vue?vue&type=style&index=0&id=0b60c6c7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b60c6c7"]])

export default __exports__